<template>
    <div ref="animationContainer">
        <div v-if="showItems.indexOf('1')!=-1">
            <div style="" class="introduce-container introduce-container1">
                <div class="introduce-container1-item">
                    <div style=" " class="animation-text big-title introduce-container1-item-title">
                        POUR PEAUX<br />
                        SENSIBLES
                    </div>
                    <div style="padding: 1.0416666666666665vw 0% 1.0416666666666665vw 0%; border-left: 2px solid rgba(34, 34, 34, 1);">
                        <div style="margin: 0.992685vw 26.0274% 0vw 4.10959%; font-weight: bold; color: rgb(34, 34, 34); font-family: MiSans-Regular; " class="animation-text content">
                            SAIN POUR LES PEAUX SENSIBLES
                        </div>
                        <div style="margin: 20px 22.1918% 0vw 4.10959%;line-height: 1.5; color: #333; font-family: MiSans-Light;" class="animation-text">NOUS SOMMES INTRANSIGEANTS SUR CE QUI ENTRE DANS NOS PRODUITS (ET CE QUI EN RESTE EXCLU). NOTRE THÉRAPEUTE APPELLE ÇA « POSER DES LIMITES SAINES ».</div>
                        <div style="margin: 3.992685vw 26.0274% 0vw 4.10959%; font-weight: bold; color: rgb(34, 34, 34);" class="animation-text content">
                            SOINS DE LA PEAU BIO
                        </div>
                        <div style="margin: 20px 22.1918% 0vw 4.10959%;  line-height: 1.5; color: #333; font-family: MiSans-Light; " class="animation-text content">
                            LIBÉREZ LA PUISSANCE DE LA NATURE AVEC DES SOINS BIO EFFICACES.
                        </div>
                    </div>
                </div>
                <div style=" display: flex; flex-wrap: wrap;" class="introduce-container1-item">
                    <div  class="animation-crad introduce-container1-item-image">
                        <img src="../assets/projects/SENSITIVE_01.png" style="width: 100%; " class="custom-image " loading="lazy" decoding="async" />
                    </div>
                    <div class="animation-crad introduce-container1-item-image">
                        <img src="../assets/projects/SENSITIVE_11.jpg" style="width: 100%; " class="custom-image" loading="lazy" decoding="async" />
                    </div>
                    <div class="animation-crad introduce-container1-item-image">
                        <img src="../assets/projects/SENSITIVE_10.jpg" style="width: 100%; " class="custom-image" loading="lazy" decoding="async" />
                    </div>
                    <div class="animation-crad introduce-container1-item-image">
                        <img src="../assets/projects/SENSITIVE_02.png" style="width: 100%; " class="custom-image" loading="lazy" decoding="async" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showItems.indexOf('2')!=-1">
            <div style="display: flex;" class="introduce-container introduce-container2">
                <div class="introduce-container2-item1">
                    <div class="custom-image-container">
                        <img src="../assets/projects/SENSITIVE_07.png" style="width: 100%; " class="custom-image" loading="lazy" decoding="async" />
                    </div>
                </div>
                <div class="introduce-container2-item2">
                    <div class="animation-title big-title pd-left-150">
                        SIMPLE,<br />
                        NATURAL,<span class="big-title-art">E</span>FFECTIVE
                    </div>
                    <div style="display: flex;" class="pd-left-150 ma-top-120 introduce-container2-text ">
                        <div style="flex: 1; font-size: 20px; ">
                            <div style=" color: rgb(34, 34, 34); font-family: MiSans-Regular;" class="animation-text ma-top-60">
                                CRÈME CONTOUR DES YEUX
                            </div>
                            <div style="margin-top: 10px; color: rgb(34, 34, 34);" class="animation-text">
                                INTENSIVE CELLULAIRE ET NOURRISSANTE
                            </div>
                            <div style=" font-size: 18px; line-height: 30px; color: rgb(102, 102, 102); font-family: MiSans-Light; " class="animation-text mr-top-30">
                                Grâce à sa formule performante à base d'ingrédients naturels, il restaure l'équilibre et prend soin du contour de l'œil.
                            </div>
                        </div>
                        <div style="flex: 1; text-align: center;">
                            <img src="../assets/projects/06_1.jpg" class="custom-image introduce-container2-image" loading="lazy" decoding="async" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="showItems.indexOf('3')!=-1 && products.length>0">
            <div class="introduce-container introduce-container3">
                <div class="introduce-container3-item">
                    <a :href="$router.resolve({ name: 'Product', query: { id: products[9] ? products[9].id : '' } }).href" target="_blank">
                        <div class="image-card">
                            <div class="image-container">
                                <div class="image-front">
                                    <div class="zoom-effect">
                                        <img src="../assets/projects/SENSITIVE_08.png" style="width: 100%; " class="zoom-image" loading="lazy" decoding="async" />
                                    </div>
                                </div>
                                <div class="image-back" :style="{ backgroundImage: `url(${(products[9]?products[9].image:'')})` }">
                                </div>
                            </div>
                        </div>
                    </a>
                    <div style="padding:0 10px;">
                        <div style="margin-top: 2.089864158829676vw;" class="custom-title animation-text">
                            NETTOYANT VISAGE
                        </div>
                        <div class="custom-title animation-text">
                            ★★★★★
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            « J’ADORE ce nettoyant ! Ayant la peau sensible, il élimine tout mon maquillage sans dessécher ma peau. Mon visage est doux et ne tiraille jamais. Je vais le racheter pour toujours ! »
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            —— Emily, Peau Mixte
                        </div>
                    </div>
                </div>
                <div class="introduce-container3-item">
                    <a :href="$router.resolve({ name: 'Product', query: { id: products[5] ? products[5].id : '' } }).href" target="_blank">
                        <div class="image-card">
                            <div class="image-container">
                                <div class="image-front">
                                    <div class="zoom-effect">
                                        <img src="../assets/projects/SENSITIVE_09.png" style="width: 100%; " class="zoom-image" loading="lazy" decoding="async" />
                                    </div>
                                </div>
                                <div class="image-back" :style="{ backgroundImage: `url(${(products[5]?products[5].image:'')})` }">
                                </div>
                            </div>
                        </div>
                    </a>
                    <div style="padding:0 10px;">
                        <div style="margin-top: 2.089864158829676vw;" class="custom-title animation-text">
                            CRÈME HYDRATANTE VISAGE
                        </div>
                        <div class="custom-title animation-text">
                            ★★★★★
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            « LA meilleure crème pour les hivers secs ! Elle pénètre rapidement et ma peau reste rebondie toute la journée. Même mes zones de desquamation ont disparu. 10/10, je recommande ! »
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            —— Jessica, Peau Sèche
                        </div>
                    </div>
                </div>
                <div  class="introduce-container3-item">
                    <a :href="$router.resolve({ name: 'Product', query: { id: products[1] ? products[1].id : '' } }).href" target="_blank">
                        <div class="image-card">
                            <div class="image-container">
                                <div class="image-front">
                                    <div class="zoom-effect">
                                        <img src="../assets/projects/SENSITIVE_01.png" style="width: 100%; " class="zoom-image" loading="lazy" decoding="async" />
                                    </div>
                                </div>
                                <div class="image-back" :style="{ backgroundImage: `url(${(products[1]?products[1].image:'')})` }">
                                </div>
                            </div>
                        </div>
                    </a>
                    <div style="padding:0 10px;">
                        <div style="margin-top: 2.089864158829676vw;" class="custom-title animation-text">
                            SÉRUM ANTI-ÂGE
                        </div>
                        <div class="custom-title animation-text">
                            ★★★★★
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            « Ce sérum a tout changé ! Les ridules autour de mes yeux ont visiblement diminué en 3 semaines. Une texture légère et aucune irritation. Il vaut chaque centime ! »
                        </div>
                        <div class="custom-content animation-text mr-top-40">
                            —— Sarah, Peau Mûre
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { createScrollReveal, refreshScrollReveal } from '../utils/scrollReveal'

    export default {
        name: 'PeoductIntroduce',
        props: {
            showItems: Array,
            products: Array
        },
        data() {
            return {
                revealCleanup: null
            }
        },
        watch: {
            products() {
                this.$nextTick(() => {
                    refreshScrollReveal()
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.revealCleanup = createScrollReveal(this.$refs.animationContainer)
            });
        },
        beforeUnmount() {
            if (this.revealCleanup) {
                this.revealCleanup()
                this.revealCleanup = null
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .image-card {
        height: 530px;
        perspective: 1000px;
        cursor: pointer;
    }

    .image-container {
        width: 100%;
        height: 100%;
        position: relative;
        transition: transform 0.42s ease;
        transform-style: preserve-3d;
    }

    .image-card:hover .image-container {
        transform: translateY(-6px);
    }

    .image-front, .image-back {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        border-radius: 15px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        transition: transform 0.42s ease, box-shadow 0.42s ease;
        will-change: transform;
    }

    .image-back {
        transform: rotateY(180deg);
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 24px;
        font-weight: bold;
        background-size: cover;
        background-position: 50%;
        background-size: 300px;
        background-repeat: no-repeat;
        background-color: #f1f0ee;
    }

    .image-card:hover .image-front {
        transform: rotateY(180deg);
    }

    .image-card:hover .image-back {
        transform: rotateY(0deg);
    }

    .image-placeholder {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .zoom-effect {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .zoom-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.36s ease;
    }

    .image-card:hover .zoom-image {
        transform: scale(1.08);
    }

    .image-info {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        padding: 20px;
        color: white;
        transform: translateY(100%);
        transition: transform 0.3s ease;
    }

    .image-card:hover .image-info {
        transform: translateY(0);
    }

    @media (hover: none), (max-width: 768px) {
        .image-card:hover .image-container,
        .image-card:hover .image-front,
        .image-card:hover .image-back,
        .image-card:hover .zoom-image {
            transform: none;
        }

        .image-front, .image-back {
            transition-duration: 0.22s;
            will-change: auto;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .image-container,
        .image-front,
        .image-back,
        .zoom-image,
        .image-info {
            transition: none;
        }
    }
</style>

